// Types
import * as Types from '../types'
import {  successGenerate } from "../../common";

const actionSetLastCacheTime = () => ({
  type: successGenerate(Types.SET_LAST_CACHE_TIME),
})

export {
  actionSetLastCacheTime,
};